import { useQuery } from '@tanstack/react-query';
import { getDatamateByIdWithStats, getDatamates, getDatamatesWithStats } from "@/helpers/apis";
import { TeammatesApplicableFor } from "./constants";

const useTeammates = (enabled = true) => {
  const query = useQuery({
    queryKey: [`FILTER_${TeammatesApplicableFor}`],
    queryFn: () => getDatamates(),
    enabled
  });

  return { ...query, data: query.data?.datamates };
};

export const useTeammatesWithStats = (params?: { start_date: string; end_date: string }) => {
  const query = useQuery({
    queryKey: [`FILTER_${TeammatesApplicableFor}`, params?.start_date, params?.end_date],
    queryFn: () => getDatamatesWithStats(params),
  });
  return { ...query, data: query.data?.datamates, usage: query.data?.usage };
};

export default useTeammates;

export const useTeammateByIdWithStats = (
  datamateId: string | undefined,
  startDate: Date,
  endDate: Date
) => {
  return useQuery({
    queryKey: ["datamate-with-stats", datamateId, startDate, endDate],
    queryFn: () =>
      getDatamateByIdWithStats(datamateId, {
        start_date: startDate.toISOString(),
        end_date: endDate.toISOString(),
      }),
    enabled: datamateId !== undefined,
  });
};
